export default {
  basic: '0 2px 4px #ddd'
};
